// extracted by mini-css-extract-plugin
module.exports = {"swiper":"styles_swiper__iSNl_","wrapper":"styles_wrapper__kmjrN","markdown":"styles_markdown__1xGEB","bullet":"styles_bullet__PQDOY"};